import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
// @mui
import { LoadingButton } from '@mui/lab';
import { Box, Card, Grid, Typography } from '@mui/material';
import Button from '@mui/material/Button';
// components
import { endpoints } from 'src/utils/axios';
import { postRequest } from 'src/services';
import { handleErrorMessages } from 'src/components/risk-management/risk-register/feching';
import { useSnackbar } from 'src/components/snackbar';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import FormProvider from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import Checkbox from '@mui/material/Checkbox';
import { useRouter } from 'src/routes/hooks';
import ActivityFirstRow from './activity-first-row';
import ActivitySecondRow from './activity-second-row';
import ActivityThirdRow from './activity-third-row';
import ActivityFourthRow from './activity-fourth-row';
import ActivityFifthRow from './activity-fifth-row';
import ActivitySixthRow from './activity-sixth-row';
import ActivityCalculationRow from './activity-calculation-row ';
import ActivityScheduleRow from './activity-schedule-row ';
import ActivityAssigntaskRow from './activity-assign-task-row ';
import { useBoolean } from 'src/hooks/use-boolean';
import MarkupModal from 'src/components/activity-modals/markup-modal';
import DiscountModal from 'src/components/activity-modals/discount-modal';
import EscalationModal from 'src/components/activity-modals/escalation-modal';
import TaxModal from 'src/components/activity-modals/tax-modal';
import ContingencyModal from 'src/components/activity-modals/contingency-modal';
import TradeWorkTitle from 'src/components/activity-modals/trade-work-title';
import axios from 'axios';
import { LoadingScreen } from 'src/components/loading-screen';
import { baseURLStaging } from 'src/config-global';
import {
  calculationOfLaborCost,
  calculationOfMaterialCost,
  calculationOfEquipmentCost,
  calculationOfSubcontractorCost,
  calculationOfWorkdays,
  calculationOfLabourHrs,
  calculationOfDirectCost,
  calculationOfDirectUnitPrice,
  calculationOfMarkupBidUnitPrice,
  calculationOfMarkupCost,
  calculationOfLaborCostInDetail,
  calculationOfLaborHrsInDetail,
  calculationOfLaborUnitPrice,
  calculationOfDirectCostInSimpleResource,
} from './utils/calculation';
import { CalculateMarkupDetails } from './utils/details-model-calculations';
import { addDays } from 'date-fns';
import { useData } from 'src/contexts/gantt-chart/gantt-context';
import DetailsModal from './activity-details-modals/details-modal';
import { useParams } from 'react-router';

// ----------------------------------------------------------------------
export default function AddEditActivity() {
  const { id } = useParams();
  const router = useRouter();
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);

  const markup = useBoolean();
  const markupDetails = useBoolean();
  const contingency = useBoolean();
  const contingencyDetails = useBoolean();
  const escalation = useBoolean();
  const escalationDetails = useBoolean();
  const tax = useBoolean();
  const taxDetails = useBoolean();
  const discount = useBoolean();
  const discountDetails = useBoolean();

  const modalConfig = [
    { key: 'markup', type: 'Markup', multiplyKey: 'multiplyOnMarkup', state: markupDetails },
    {
      key: 'contingency',
      type: 'Contingency',
      multiplyKey: 'multiplyOnContingency',
      state: contingencyDetails,
    },
    {
      key: 'escalation',
      type: 'Escalation',
      multiplyKey: 'multiplyOnEscalation',
      state: escalationDetails,
    },
    { key: 'tax', type: 'Tax', multiplyKey: 'multiplyOnTax', state: taxDetails },
    {
      key: 'discount',
      type: 'Discount',
      multiplyKey: 'multiplyOnDiscount',
      state: discountDetails,
    },
  ];

  const tradeWork = useBoolean();
  const { completeData, loading: settingLoading, refreshData } = useData();

  const [allow, setAllow] = useState(true);
  const [tradeWorkTitles, setTradeWorkTitles] = useState([]);
  const [markupSetupData, setMarkupSetupData] = useState([]);

  const isActivitySetToUnitPrice = allow?.type_activity_breakdown_calculation === 'Unit Price';
  const isLaborHrsSetToDetail = allow?.type_labor_hours_calculation === 'Detail';
  const isHourlyRateSetToManual = allow?.type_hourly_rate_calculation === 'Manual';
  const isMarkupSetToMarkup = allow?.type_markup_setup === 'Markup';

  useEffect(() => {
    refreshData();
  }, []);

  useEffect(() => {
    console.log(completeData, 'what happeing ');
    setAllow(completeData?.metadata?.cost_code_settings);
    setValue('resource_type', completeData?.metadata?.project?.default_resource_type);
    if (completeData?.metadata?.cost_code_settings) {
      setValue('difficulty_factor', completeData?.metadata?.cost_code_settings?.difficulty_factor);
      setValue('shift_hours', completeData?.metadata?.cost_code_settings?.shift_hours);
      setValue('shift_rate_type', completeData?.metadata?.cost_code_settings?.type_shift_rate);

      setTradeWorkTitles(completeData?.trade_worker_titles || []);
      setMarkupSetupData(completeData?.markup_setup || []);

      // Markup
      const findMarkup = completeData?.markup_setup?.markups?.find(
        (item) => item.id === completeData?.metadata?.cost_code_settings?.planned_markup_id
      );
      if (findMarkup) {
        setValue('markup', { ...findMarkup, name: findMarkup.markup_table_name });
      }

      // Contingency
      const findContingency = completeData?.markup_setup?.contingencies?.find(
        (item) => item.id === completeData?.metadata?.cost_code_settings?.planned_contingency_id
      );
      if (findContingency) {
        setValue('contingency', {
          ...findContingency,
          name: findContingency.contingency_table_name,
        });
      }

      // Escalation
      const findEscalation = completeData?.markup_setup?.escalations?.find(
        (item) => item.id === completeData?.metadata?.cost_code_settings?.planned_escalation_id
      );
      if (findEscalation) {
        setValue('escalation', { ...findEscalation, name: findEscalation.escalation_code });
      }

      // Tax
      const findTax = completeData?.markup_setup?.taxes?.find(
        (item) => item.id === completeData?.metadata?.cost_code_settings?.planned_tax_id
      );
      if (findTax) {
        setValue('tax', { ...findTax, name: findTax.tax_table_name });
      }

      // Discount
      const findDiscount = completeData?.markup_setup?.discounts?.find(
        (item) => item.id === completeData?.metadata?.cost_code_settings?.planned_discount_id
      );
      if (findDiscount) {
        setValue('discount', { ...findDiscount, name: findDiscount.discount_table_name });
      }

      // delete me
      // setValue('labor_cost', '1000');
      // setValue('material_cost', '1000');
      // setValue('equipment_cost', '1000');
      // setValue('subcontractor_cost', '1000');
      // setValue('other_cost', '100');
      // setValue('direct_cost', '4100');
    }
  }, [completeData]);

  const [checkBoxOptions, setCheckBoxOptions] = useState({
    isCalculation: false,
    isSchedule: false,
    isAssignedTask: false,
  });
  let AttachMoneyIcon = (
    <Iconify icon="mdi:dollar" style={{ fontSize: '25px', marginTop: '7px' }} />
  );
  let PercentIcon = (
    <Iconify icon="mdi:percent-outline" style={{ fontSize: '25px', marginTop: '7px' }} />
  );
  let AccessTimeIcon = '';

  // Validation schema
  const NewUserSchema = Yup.object().shape({
    resource_type: Yup.string().nullable(),
    activity: Yup.string().required('Cost Code Activity is required'),
    description: Yup.string().required('Cost Code Task Description is required'),
    quantity: Yup.string().required('Quantity is required'),
    unit: Yup.string().required('Unit is required'),
    daily_production_rate_per_shift: Yup.string().nullable(),
    difficulty_factor: Yup.string().nullable(),
    no_of_shifts: Yup.string().nullable(),
    shift_hours: Yup.string().nullable(),
    number_of_workers: Yup.string().nullable(),
    trade_work_titles: Yup.string().nullable(),
    shift_rate_type: Yup.string().nullable(),
    labor_hourly_rate: Yup.string().nullable(),
    labor_unit_price: Yup.string().nullable(),
    labor_cost: Yup.string().nullable(),
    material_unit_price: Yup.string().nullable(),
    material_cost: Yup.string().nullable(),
    equipment_unit_price: Yup.string().nullable(),
    equipment_cost: Yup.string().nullable(),
    subcontractor_unit_price: Yup.string().nullable(),
    subcontractor_cost: Yup.string().nullable(),
    other_cost: Yup.string().nullable(),
    mark_up_percent: Yup.string().nullable(),
    work_days: Yup.string().nullable(),
    labor_hours: Yup.string().nullable(),
    direct_unit_price: Yup.string().nullable(),
    direct_cost: Yup.string().nullable(),
    mark_up_cost: Yup.string().nullable(),
    bid_amount: Yup.string().nullable(),
    bid_unit_price: Yup.string().nullable(),
    predecessor_activities: Yup.string().nullable(),
    successor: Yup.string().nullable(),
    duration:
      checkBoxOptions.isSchedule === true
        ? Yup.string().required('Duration is required')
        : Yup.string().nullable(),
    start_date: Yup.string().nullable(),
    end_date: Yup.string().nullable(),
  });

  const defaultValues = useMemo(
    () => ({
      resource_type: 'Detailed',
      // name: '',
      activity: '',
      description: '',
      quantity: '',
      unit: '',
      daily_production_rate_per_shift: '',
      difficulty_factor: '',
      no_of_shifts: '1',
      shift_hours: '',
      number_of_workers: '',
      trade_work_titles: '',
      shift_rate_type: '',
      labor_hourly_rate: '',
      labor_unit_price: '',
      labor_cost: '0',
      material_unit_price: '',
      material_cost: '0',
      equipment_unit_price: '',
      equipment_cost: '0',
      subcontractor_unit_price: '',
      subcontractor_cost: '0',
      other_cost: '0',
      mark_up_percent: '',
      markup: '',
      markupDetails: '',
      multiplyOnMarkup: {},
      contingency: '',
      contingencyDetails: '',
      multiplyOnContingency: { markup: false },
      escalation: '',
      escalationDetails: '',
      multiplyOnEscalation: { markup: false, contingency: false },
      tax: '',
      taxDetails: '',
      multiplyOnTax: { markup: false, contingency: false, escalation: false },
      discount: '',
      discountDetails: '',
      multiplyOnDiscount: { markup: false, contingency: false, escalation: false, tax: false },
      work_days: '',
      labor_hours: '',
      direct_unit_price: '',
      direct_cost: '0',
      mark_up_cost: '',
      bid_amount: '',
      bid_unit_price: '',
      predecessor_activities: '',
      successor: '',
      duration: 1,
      start_date: new Date(),
      end_date: new Date(),
    }),
    []
  );

  function handleCheckBox(e) {
    const name = e.target.name;
    const isChecked = e.target.checked;
    name === 'calculation'
      ? setCheckBoxOptions({ ...checkBoxOptions, isCalculation: isChecked })
      : name === 'schedule'
      ? setCheckBoxOptions({ ...checkBoxOptions, isSchedule: isChecked })
      : name === 'assign' && setCheckBoxOptions({ ...checkBoxOptions, isAssignedTask: isChecked });
  }

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });

  const {
    reset,
    watch,
    control,
    setValue,
    setError,
    clearErrors,
    getValues,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods;

  const values = watch();

  const isDetailedResource = values.resource_type === 'Detailed';

  useEffect(() => {
    reset(defaultValues);
  }, [reset, defaultValues]);

  const onSubmit = handleSubmit(async (data) => {
    try {
      const responseData = await postRequest(
        endpoints.ganttChart.post_cost_code_activities,
        {
          planned_cost_code_category_id: id,
          code: data.activity,
          description: data.description,
          quantity: data.quantity,
          unit_price: data.direct_unit_price,
          //
          unit: data.unit,
          budgeted_amount: data.direct_cost,
          budgeted_hours: data.labor_hours,

          hourly_rate: data.labor_hourly_rate,
          planned_labor_cost: data.labor_cost,
          planned_material_cost: data.material_cost,
          planned_equipment_cost: data.equipment_cost,
          planned_subcontractor_cost: data.subcontractor_cost,
          mark_ups: data.mark_up_cost || 0,
          planned_start_date: new Date(data.start_date).toISOString().split('T')[0],
          planned_finish_date: new Date(data.end_date).toISOString().split('T')[0],
          duration: data.duration,
        },
        false
      );

      if (responseData.metadata && responseData.metadata.success) {
        reset();
        enqueueSnackbar({
          variant: 'success',
          message: 'Activity added successfully',
        });
        router.push(`/gantt-chart`);
      } else {
        handleErrorMessages(responseData.message);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  });

  // Unit Calculations
  const calculationofLaborCost = useCallback(calculationOfLaborCost(setValue, getValues), [
    setValue,
    getValues,
  ]);
  const calculationofMaterialCost = useCallback(calculationOfMaterialCost(setValue, getValues), [
    setValue,
    getValues,
  ]);
  const calculationofEquipmentCost = useCallback(calculationOfEquipmentCost(setValue, getValues), [
    setValue,
    getValues,
  ]);
  const calculationofSubcontractorCost = useCallback(
    calculationOfSubcontractorCost(setValue, getValues),
    [setValue, getValues]
  );

  // Detail calculations
  const calculationofLaborCostInDetail = useCallback(
    calculationOfLaborCostInDetail(setValue, getValues),
    [setValue, getValues]
  );
  const calculationofLaborHrsInDetail = useCallback(
    calculationOfLaborHrsInDetail(setValue, getValues),
    [setValue, getValues]
  );

  // Unit calculations && Detail calculations
  const calculationofLaborUnitPrice = useCallback(
    calculationOfLaborUnitPrice(setValue, getValues),
    [setValue, getValues]
  );

  // Calculate in details percentages
  //

  // Base Calculations
  const calculationofWorkdays = useCallback(calculationOfWorkdays(setValue, getValues), [
    setValue,
    getValues,
  ]);
  const calculationofLabourHrs = useCallback(calculationOfLabourHrs(setValue, getValues), [
    setValue,
    getValues,
  ]);
  const calculationofDirectCost = useCallback(calculationOfDirectCost(setValue, getValues), [
    setValue,
    getValues,
  ]);
  const calculationofDirectUnitPrice = useCallback(
    calculationOfDirectUnitPrice(setValue, getValues),
    [setValue, getValues]
  );
  const calculationofDirectCostInSimpleResource = useCallback(
    calculationOfDirectCostInSimpleResource(setValue, getValues),
    [setValue, getValues]
  );
  const calculationofMarkupCost = useCallback(calculationOfMarkupCost(setValue, getValues), [
    setValue,
    getValues,
  ]);
  const calculationofMarkupBidUnitPrice = useCallback(
    calculationOfMarkupBidUnitPrice(setValue, getValues),
    [setValue, getValues]
  );

  const handleChangeDuration = useCallback(
    (event, index) => {
      const duration = Number(event.target.value);
      if (!isNaN(duration) && typeof duration === 'number') {
        const startDate = getValues('start_date');
        if (startDate) {
          const endDate = addDays(new Date(startDate), duration);
          setValue('duration', duration.toFixed(2));
          setValue('end_date', endDate);
        }
      }
    },
    [setValue, getValues]
  );
  const handleStartDateChange = useCallback(
    (value) => {
      const duration = getValues('duration');
      if (!isNaN(duration) && typeof duration === 'number') {
        const startDate = getValues('start_date');
        if (startDate) {
          const endDate = addDays(value, duration);
          setValue('start_date', value);
          setValue('end_date', endDate);
        } else {
        }
      } else {
        setValue('end_date', value);
      }
    },
    [setValue, getValues]
  );

  // Calculate Labor Hourly Rate
  useEffect(() => {
    const changeLaborHourlyRate = (rate) => {
      setValue('labor_hourly_rate', rate);
      if (!isLaborHrsSetToDetail) {
        calculationofLabourHrs(rate, 'labor_hourly_rate');
      } else {
        calculationofLaborCostInDetail(rate, 'labor_hourly_rate');
      }
    };

    if (values.shift_rate_type && values.trade_work_titles) {
      const selectedTrade = tradeWorkTitles.find((item) => item.name == values.trade_work_titles);
      if (selectedTrade) {
        const rateTypeMap = {
          'Regular Time Rate': 'regular_time_rate',
          'Over Time Rate': 'over_time_rate',
          'Double Time Rate': 'double_time_rate',
        };

        const laborHourlyRate = selectedTrade?.[rateTypeMap[values.shift_rate_type]];

        changeLaborHourlyRate(laborHourlyRate);
      }
    } else {
      changeLaborHourlyRate(0);
    }
  }, [values.shift_rate_type, values.trade_work_titles]);

  // Calculate details percentages
  useEffect(() => {
    if (!isMarkupSetToMarkup) {
      CalculateMarkupDetails(values, setValue);
    }
  }, [values.direct_cost]);

  return (
    <>
      {settingLoading || !allow ? (
        <Box sx={{ height: '50vh', width: '100%' }}>
          <LoadingScreen />
        </Box>
      ) : (
        <>
          <FormProvider methods={methods} onSubmit={onSubmit}>
            <Box
              mt={2}
              mb={2}
              gap={3}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(2, 1fr)',
                lg: 'repeat(4, 1fr)',
              }}
            >
              <ActivityFirstRow
                isDetailedResource={isDetailedResource}
                calculationofLaborCost={calculationofLaborCost}
                calculationofMaterialCost={calculationofMaterialCost}
                calculationofEquipmentCost={calculationofEquipmentCost}
                calculationofSubcontractorCost={calculationofSubcontractorCost}
                calculationofLaborUnitPrice={calculationofLaborUnitPrice}
                showUnitFields={isActivitySetToUnitPrice}
                showDetailFields={isLaborHrsSetToDetail}
                isUnitAndDetailSetting={isActivitySetToUnitPrice && isLaborHrsSetToDetail}
                calculationofWorkdays={calculationofWorkdays}
                calculationofMarkupBidUnitPrice={calculationofMarkupBidUnitPrice}
                calculationofDirectUnitPrice={calculationofDirectUnitPrice}
                calculationofDirectCostInSimpleResource={calculationofDirectCostInSimpleResource}
              />
              {/* Activity rows 2-5 */}
              {isDetailedResource && (
                <>
                  {isLaborHrsSetToDetail && (
                    <ActivitySecondRow
                      calculationofWorkdays={calculationofWorkdays}
                      calculationofLaborHrsInDetail={calculationofLaborHrsInDetail}
                    />
                  )}
                  <ActivityThirdRow
                    calculationofLabourHrs={calculationofLabourHrs}
                    calculationofLaborCostInDetail={calculationofLaborCostInDetail}
                    calculationofLaborHrsInDetail={calculationofLaborHrsInDetail}
                    showTradeWorkAndHourlyRate={!isHourlyRateSetToManual}
                    tradeWorkTitles={tradeWorkTitles}
                    showDetailFields={isLaborHrsSetToDetail}
                    icon={AttachMoneyIcon}
                    onTradeAdd={tradeWork.onTrue}
                    setTradeWorkTitles={setTradeWorkTitles}
                  />
                  <ActivityFourthRow
                    calculationofLaborCost={calculationofLaborCost}
                    calculationofMaterialCost={calculationofMaterialCost}
                    calculationofDirectCost={calculationofDirectCost}
                    calculationofLabourHrs={calculationofLabourHrs}
                    showUnitFields={isActivitySetToUnitPrice}
                    showDetailFields={isLaborHrsSetToDetail}
                    isUnitAndDetailSetting={isActivitySetToUnitPrice && isLaborHrsSetToDetail}
                    icon={AttachMoneyIcon}
                  />
                  <ActivityFifthRow
                    calculationofDirectCost={calculationofDirectCost}
                    calculationofEquipmentCost={calculationofEquipmentCost}
                    calculationofSubcontractorCost={calculationofSubcontractorCost}
                    showUnitFields={isActivitySetToUnitPrice}
                    icon={AttachMoneyIcon}
                  />
                </>
              )}

              <ActivitySixthRow
                values={values}
                setValue={setValue}
                icon={AttachMoneyIcon}
                isDetailedResource={isDetailedResource}
                showDropdowns={!isMarkupSetToMarkup}
                calculationofDirectCostInSimpleResource={calculationofDirectCostInSimpleResource}
                calculationofDirectCost={calculationofDirectCost}
                calculationofMarkupCost={calculationofMarkupCost}
                enableDropdown={allow.markup_setup_values}
                markupSetupData={markupSetupData}
                // markup
                selectedMarkup={values.markup}
                onMarkupAdd={markup.onTrue}
                onShowMarkupDetails={markupDetails.onTrue}
                // contingency
                selectedContingency={values.contingency}
                onContingencyAdd={contingency.onTrue}
                onShowContingencyDetails={contingencyDetails.onTrue}
                // escalation
                selectedEscalation={values.escalation}
                onEscalationAdd={escalation.onTrue}
                onShowEscalationDetails={escalationDetails.onTrue}
                // tax
                selectedTax={values.tax}
                onTaxAdd={tax.onTrue}
                onShowTaxDetails={taxDetails.onTrue}
                // discount
                selectedDiscount={values.discount}
                onDiscountAdd={discount.onTrue}
                onShowDiscountDetails={discountDetails.onTrue}
              />
            </Box>
            <Card
              mt={2}
              gap={4}
              sx={{ p: 2, display: 'flex', flexDirection: 'row', alignItems: 'center' }}
            >
              <Box display="flex" alignItems="center">
                <Typography variant="h6" sx={{ fontSize: '0.2rem' }}>
                  Calculation
                </Typography>
                <Checkbox
                  name="calculation"
                  label="Calculation"
                  onClick={handleCheckBox}
                  value={checkBoxOptions.isCalculation}
                />
              </Box>
              <Box ml={5} display="flex" alignItems="center">
                <Typography variant="h6" sx={{ fontSize: '0.2rem' }}>
                  Schedule
                </Typography>
                <Checkbox
                  name="schedule"
                  label="Schedule"
                  onClick={handleCheckBox}
                  value={checkBoxOptions.isSchedule}
                />
              </Box>
              <Box ml={5} display="flex" alignItems="center">
                <Typography variant="h6" sx={{ fontSize: '0.2rem' }}>
                  Assign Task
                </Typography>
                <Checkbox
                  name="assign"
                  label="Assign Task"
                  onClick={handleCheckBox}
                  value={checkBoxOptions.isAssignedTask}
                />
              </Box>
              <Box ml={5} display="flex" alignItems="center">
                <Typography variant="h6" sx={{ fontSize: '0.2rem' }}>
                  Save it for Future or data base
                </Typography>
                <Checkbox name="save" label="Save it for Future or data base" />
              </Box>
            </Card>
            {checkBoxOptions.isCalculation === true && (
              <ActivityCalculationRow
                icon={AttachMoneyIcon}
                AccessTimeIcon={AccessTimeIcon}
                isDetailedResource={isDetailedResource}
                showMarkupCost={isMarkupSetToMarkup}
                showDetailFields={isLaborHrsSetToDetail}
              />
            )}
            {checkBoxOptions.isSchedule === true && (
              <ActivityScheduleRow
                handleStartDateChange={handleStartDateChange}
                handleChangeDuration={handleChangeDuration}
                control={control}
                setValue={setValue}
                setError={setError}
                methods={methods}
                clearErrors={clearErrors}
                showDetailFields={isLaborHrsSetToDetail}
              />
            )}
            {checkBoxOptions.isAssignedTask === true && <ActivityAssigntaskRow />}
            <Box display="flex" justifyContent="end" gap={1} mt={5}>
              <Button variant="outlined" className="danager" onClick={router.back}>
                Cancel
              </Button>
              <LoadingButton loading={loading} variant="contained" onClick={onSubmit}>
                Submit
              </LoadingButton>
            </Box>
          </FormProvider>
          <MarkupModal
            isOpen={markup.value}
            handleClose={markup.onFalse}
            PercentIcon={PercentIcon}
            hideDetails={!isDetailedResource}
          />
          <ContingencyModal
            isOpen={contingency.value}
            handleClose={contingency.onFalse}
            PercentIcon={PercentIcon}
            hideDetails={!isDetailedResource}
          />
          <EscalationModal
            isOpen={escalation.value}
            handleClose={escalation.onFalse}
            PercentIcon={PercentIcon}
            hideDetails={!isDetailedResource}
          />
          <TaxModal
            isOpen={tax.value}
            handleClose={tax.onFalse}
            PercentIcon={PercentIcon}
            hideDetails={!isDetailedResource}
          />
          <DiscountModal
            isOpen={discount.value}
            handleClose={discount.onFalse}
            PercentIcon={PercentIcon}
            hideDetails={!isDetailedResource}
          />
          {modalConfig.map(({ key, type, multiplyKey, state }) => (
            <Fragment key={key}>
              {values[key] && (
                <DetailsModal
                  type={type}
                  currentMultiply={multiplyKey}
                  isOpen={state.value}
                  handleClose={state.onFalse}
                  formData={values}
                  setValue={setValue}
                  getValues={getValues}
                  isDetailedResource={isDetailedResource}
                />
              )}
            </Fragment>
          ))}

          <TradeWorkTitle
            isOpen={tradeWork.value}
            handleClose={tradeWork.onFalse}
            reload={(titles) => setTradeWorkTitles(titles)}
            AttachMoneyIcon={AttachMoneyIcon}
          />
        </>
      )}
    </>
  );
}
